export interface AuditLog {
    organizationIdentifier: number;
    organizationName: string;
    initiator: string;
    timeStamp: Date;
    message: string;
}

export interface AuditLogGetParams {
    organizationIds?: number[];
    initiators?: string[];
    fromDate?: Date;
    toDate?: Date;
}
